module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av269-b081742e25dcf1cd85d376469a19baf1.jpg";